window.addEventListener('DOMContentLoaded', () => {
    function initNavHeader() {
      const navHeader = $('.nav-header-fixed');

      scrollToFaq()
      if (navHeader.attr('data-settings') != 'true') return;
      let worryFreeH = $('.worry-free').height() ?? 0;
      let headerDomH = $('.header-new').height() ?? 0;
      navHeader.css({
        top: headerDomH + 'px',
      });

      window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > worryFreeH + headerDomH) {
          navHeader.addClass('nav-header-fixed-us');
        } else {
          navHeader.removeClass('nav-header-fixed-us');
        }
      });
    }
    initNavHeader();

    function scrollToFaq(){
      $('#nav-right-a-to').on('click', () => {
        $('html, body').animate(
          {
            scrollTop: $('#portable-power-faq').offset().top,
          },
          500
        );
      });
    }

    let isInEditor = false;
    $('iframe', window.parent.parent.document).each(function () {
      if ($(this).attr('src')) {
        if ($(this).attr('src').includes('/admin/online-store')) {
          isInEditor = true;
          return false;
        }
      }
    });

    const techspecs_container = document.querySelector('.shopify-section.techspecs__container');
    const istab = document.querySelector('.page-layout.nav-header-fixed').dataset.istab
    if (techspecs_container && istab == 'true') {
      $('.nav-header-element-content').show();
      if(!isInEditor){
        getElementContent();
      }
    }

    function getElementContent() {
      const element__main = document.querySelector('.element-content-tab.element__main');
      const element__techspecs = document.querySelector('.element-content-tab.element__techspecs');
      element__techspecs.appendChild(techspecs_container);

      let allElement = document.querySelectorAll('#MainContent .shopify-section');
      Array.from(allElement).forEach((item) => {
        if (!item.classList.contains('nav_header_fixed_') && !item.classList.contains('techspecs__container')) {
          element__main.appendChild(item);
        }
      });

      $('.nav-header-fixed-right .nav-header-tab').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
        $('.element-content-tab.' + this.dataset.id)
          .show()
          .siblings()
          .hide();
      });

      let time = 0

      $('.nav-header-fixed-right .nav-header-faq').on("click",function(){
        if(document.getElementById('__tab_main__').classList.contains('active')){
          clearTimeout(time)
          time=setTimeout(()=>{
            scrollToFaq()
          },0)
        }else{
          document.getElementById('__tab_main__').click()
          clearTimeout(time)
          time=setTimeout(()=>{
            scrollToFaq()
          },0)
        }
       
      })
    }
  });